import { Pipe, PipeTransform } from '@angular/core';

export type TreasuryDifferenceTone = 'empty' | 'zero' | 'positive' | 'negative';

const ZERO_EPSILON = 0.01;

@Pipe({ name: 'treasuryDifferenceTone', standalone: true, pure: true })
export class TreasuryDifferenceTonePipe implements PipeTransform {
  transform(value: number | null): TreasuryDifferenceTone {
    if (value === null) {
      return 'empty';
    }
    if (Math.abs(value) < ZERO_EPSILON) {
      return 'zero';
    }
    return value > 0 ? 'positive' : 'negative';
  }
}
